import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  login (callback, authToken, rmpToken, logoutToken) {
    HTTP.defaults.headers.common['Authorization'] = authToken
    let param = {
      'rmp_otp': rmpToken,
      'logout_token': logoutToken
    }
    HTTP.post('login', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getAccount (callback) {
    HTTP.get('web_name').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getQuota (callback, token) {
    HTTP.defaults.headers.common['Authorization'] = token
    HTTP.get('quota').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  logoutRMP (callback, logoutToken) {
    let param = {
      'logout_token': logoutToken
    }
    HTTP.post('rmp/logout', param).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getBusinessId (callback) {
    HTTP.get('business_info').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/accounts/index.js